<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>home</mat-icon>
            <div>
                Úprava nemovitosti
                @if (propertyDialogForm.get('type').value) {
                    <span class="hidden md:inline">
                        ({{ propertyDialogForm.get('type').value | option: ('propertyType' | listByType) }})
                    </span>
                }
            </div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'property-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form
        [formGroup]="propertyDialogForm"
        [attr.data-testid]="'property-dialog'"
        class="hypo-dialog-content"
        appHasError
        #hasError="appHasError">
        <div class="flex flex-col xl:flex-row gap-4">
            <div class="basics w-full flex flex-col">
                <h4>Základní údaje</h4>
                <app-hypo-radio
                    [label]="'Typ nemovitosti'"
                    [listName]="'propertyType'"
                    [toggleAbleOptions]="true"
                    [itemClass]="'max-md:w-full'"
                    formControlName="type">
                </app-hypo-radio>
                <app-hypo-input
                    [inputmode]="'decimal'"
                    [label]="'Hodnota nemovitosti'"
                    [mask]="'separator.0'"
                    [step]="1000"
                    [suffix]="'Kč'"
                    formControlName="value">
                </app-hypo-input>

                <div class="flex flex-row flex-wrap items-center gap-4 mt-4">
                    <div class="toggle-multi-labels">
                        <label class="flex flex-row items-center justify-start gap-2 min-h-6">
                            <span>Vlastněná</span>
                            <app-tooltip [text]="'Pokud Vám nemovitost (spolu)patří.'"></app-tooltip>
                        </label>
                        <div>
                            <mat-label>Ne</mat-label>
                            <mat-slide-toggle formControlName="isOwned" [attr.data-testid]="'isOwned'">
                                Ano
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div class="toggle-multi-labels">
                        <label class="flex flex-row items-center justify-start gap-2 min-h-6">
                            <span>Financovaná</span>
                            <app-tooltip [text]="'Nemovitost, na kterou si peníze půjčujete.'"></app-tooltip>
                        </label>
                        <div>
                            <mat-label>Ne</mat-label>
                            <mat-slide-toggle formControlName="isFunded" [attr.data-testid]="'isFunded'">
                                Ano
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div class="toggle-multi-labels">
                        <label class="flex flex-row items-center justify-start gap-2 min-h-6">
                            <span>Zastavovaná</span>
                            <app-tooltip [text]="'Nemovitost, kterou budete dávat bance do ručení.'"></app-tooltip>
                        </label>
                        <div>
                            <mat-label>Ne</mat-label>
                            <mat-slide-toggle formControlName="isPledged" [attr.data-testid]="'isPledged'">
                                Ano
                            </mat-slide-toggle>
                        </div>
                    </div>
                    @if (
                        showMore &&
                        ('isDeveloperProject' | shouldShowInput: propertyConfig.showInputOnTypes : type.value)
                    ) {
                        <div class="toggle-multi-labels">
                            <label class="flex items-center min-h-6"> Developerský projekt </label>
                            <div>
                                <mat-label>Ne</mat-label>
                                <mat-slide-toggle
                                    formControlName="isDeveloperProject"
                                    [attr.data-testid]="'isDeveloperProject'">
                                    Ano
                                </mat-slide-toggle>
                            </div>
                        </div>
                    }
                </div>
                <div class="flex flex-row gap-4">
                    @if ('housingUnitsCount' | shouldShowInput: propertyConfig.showInputOnTypes : type.value) {
                        <app-hypo-input
                            [inputmode]="'decimal'"
                            [label]="'Počet bytových jednotek'"
                            [mask]="'0000'"
                            formControlName="housingUnitsCount"
                            class="w-full">
                        </app-hypo-input>
                    }
                    @if ('commercialAreaPercentage' | shouldShowInput: propertyConfig.showInputOnTypes : type.value) {
                        <app-hypo-input
                            [dropSpecialCharacters]="false"
                            [inputmode]="'decimal'"
                            [label]="'Komerční plocha'"
                            [mask]="'0*.999'"
                            [suffix]="'%'"
                            [tooltip]="'Jedná se např. o obchod, restauraci, skladové prostory apod.'"
                            formControlName="commercialAreaPercentage"
                            class="w-full">
                        </app-hypo-input>
                    }
                </div>
                <div class="flex flex-row gap-4">
                    @if ('cadastreRegisterSeparately' | shouldShowInput: propertyConfig.showInputOnTypes : type.value) {
                        <div class="toggle-multi-labels w-full">
                            <label>Bytové jednotky jsou v katastru zapsané zvlášť</label>
                            <div>
                                <mat-label>Ne</mat-label>
                                <mat-slide-toggle
                                    formControlName="cadastreRegisterSeparately"
                                    [attr.data-testid]="'cadastreRegisterSeparately'">
                                    Ano
                                </mat-slide-toggle>
                            </div>
                        </div>
                    }
                </div>
            </div>
            @if (showMore) {
                <div class="details flex flex-col w-full">
                    <h4>Podrobnosti</h4>
                    <div class="address-picker flex flex-row items-center justify-start">
                        <span class="mr-4">Převzít adresu:</span>
                        <div class="flex flex-row flex-wrap gap:4">
                            @if (mortgage._contacts[0]?.address['permanent']) {
                                <button
                                    (click)="pickAddressFromApplicant('permanent')"
                                    class="btn btn-regular btn-xxs nowrap primary-transparent"
                                    mat-button
                                    type="button">
                                    trvalá
                                </button>
                            }
                            @if (mortgage._contacts[0]?.address['temporary']?.isActive) {
                                <button
                                    (click)="pickAddressFromApplicant('temporary')"
                                    class="btn btn-regular btn-xxs nowrap primary-transparent"
                                    mat-button
                                    type="button">
                                    dočasná
                                </button>
                            }
                            @if (
                                mortgage._contacts[0]?.address['mailing'] &&
                                !mortgage._contacts[0]?.address['mailing']?.sameAsPermanent &&
                                !mortgage._contacts[0]?.address['mailing']?.sameAsTemporary
                            ) {
                                <button
                                    (click)="pickAddressFromApplicant('mailing')"
                                    class="btn btn-regular btn-xxs nowrap primary-transparent"
                                    mat-button
                                    type="button">
                                    korespondenční
                                </button>
                            }
                            @if (
                                mortgage._contacts[0]?.address['courier'] &&
                                !mortgage._contacts[0]?.address['courier']?.sameAsPermanent &&
                                !mortgage._contacts[0]?.address['courier']?.sameAsTemporary &&
                                !mortgage._contacts[0]?.address['courier']?.sameAsMailing
                            ) {
                                <button
                                    (click)="pickAddressFromApplicant('courier')"
                                    class="btn btn-regular btn-xxs nowrap primary-transparent"
                                    mat-button
                                    type="button">
                                    kurýr
                                </button>
                            }
                        </div>
                    </div>
                    <ng-container formGroupName="address">
                        <div class="flex flex-row items-center gap-4">
                            @if ('address.street' | shouldShowInput: propertyConfig.showInputOnTypes : type.value) {
                                <app-hypo-input
                                    [conditionalRequired]="!isRequiredByType('address.street')"
                                    [inputmode]="'text'"
                                    [label]="'Ulice'"
                                    [matAutocomplete]="addressAutocomplete"
                                    formControlName="street"
                                    class="w-1/2">
                                </app-hypo-input>
                            }
                            @if (
                                'address.houseNumber' | shouldShowInput: propertyConfig.showInputOnTypes : type.value
                            ) {
                                <app-hypo-input
                                    [conditionalRequired]="
                                        propertyDialogForm.get('isDeveloperProject').value ||
                                        !isRequiredByType('address.houseNumber')
                                    "
                                    [inputmode]="'text'"
                                    [label]="'Číslo popisné'"
                                    formControlName="houseNumber"
                                    class="w-1/4">
                                </app-hypo-input>
                            }
                            @if (
                                'address.houseNumber' | shouldShowInput: propertyConfig.showInputOnTypes : type.value
                            ) {
                                <div class="flex-1">/</div>
                            }
                            @if (
                                'address.orientationNumber'
                                    | shouldShowInput: propertyConfig.showInputOnTypes : type.value
                            ) {
                                <app-hypo-input
                                    [inputmode]="'text'"
                                    [label]="'Číslo orientační'"
                                    formControlName="orientationNumber"
                                    class="w-1/4">
                                </app-hypo-input>
                            }
                        </div>
                        <div class="flex flex-row gap-4">
                            <app-hypo-input
                                [inputmode]="'numeric'"
                                [label]="'PSČ'"
                                [mask]="'000 00'"
                                [patternErrorMessage]="'Musí být 5 čísel'"
                                formControlName="zipCode"
                                class="w-1/2">
                            </app-hypo-input>
                            <app-hypo-input
                                [inputmode]="'text'"
                                [label]="'Obec'"
                                [matAutocomplete]="citiesAutocomplete"
                                formControlName="city"
                                class="w-1/2">
                            </app-hypo-input>
                        </div>
                        @if ('address.unitNumber' | shouldShowInput: propertyConfig.showInputOnTypes : type.value) {
                            <div class="flex flex-row gap-4">
                                <app-hypo-input
                                    [inputmode]="'text'"
                                    [label]="'Bytová jednotka číslo'"
                                    formControlName="unitNumber"
                                    class="w-full">
                                </app-hypo-input>
                            </div>
                        }
                        <div class="flex flex-row gap-4">
                            <app-hypo-input
                                [conditionalRequired]="!isRequiredByType('address.cadastralTerritory')"
                                [inputmode]="'text'"
                                [label]="'Katastrální území'"
                                formControlName="cadastralTerritory"
                                class="w-full">
                            </app-hypo-input>
                            @if (
                                'address.parcelNumber' | shouldShowInput: propertyConfig.showInputOnTypes : type.value
                            ) {
                                <app-hypo-input
                                    [inputmode]="'text'"
                                    [label]="'Parcela číslo'"
                                    formControlName="parcelNumber"
                                    class="w-100">
                                </app-hypo-input>
                            }
                        </div>
                    </ng-container>
                    @if (propertyDialogForm.get('isDeveloperProject').value) {
                        <div class="flex flex-row gap-4">
                            <app-hypo-input
                                [inputmode]="'text'"
                                [label]="'Název developerského projektu'"
                                formControlName="developerProject"
                                class="w-full">
                            </app-hypo-input>
                        </div>
                    }
                </div>
            }
        </div>
        @if (isSent && (!propertyMethodicIsValid || hasError.invalid)) {
            <app-info-panel>
                @if (!propertyMethodicIsValid) {
                    <div class="panel-title">
                        Nemovitost musí být obsahovat jednu či více z možností – Vlastněná, Zastavovaná nebo Financovaná
                    </div>
                } @else {
                    @if (hasError.invalid) {
                        <div class="panel-title">Prosím, vyplňte správně všechny povinné údaje.</div>
                    }
                }
            </app-info-panel>
        }
    </form>

    <div class="hypo-dialog-footer">
        <button
            (click)="continue()"
            class="btn btn-lg orange property-dialog-button-continue"
            mat-button
            type="button"
            [attr.data-testid]="'income-property-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>

<mat-autocomplete
    #addressAutocomplete="matAutocomplete"
    (optionSelected)="getAddressObject($event)"
    [panelWidth]="'300px'"
    autoActiveFirstOption>
    @for (option of ruianService.filteredAddresses | async; track option) {
        <mat-option [value]="option.objectId">
            {{ option.text }}
        </mat-option>
    }
</mat-autocomplete>

<mat-autocomplete #citiesAutocomplete="matAutocomplete" autoActiveFirstOption>
    @for (option of ruianService.filteredCities | async; track option) {
        <mat-option [value]="option">
            {{ option }}
        </mat-option>
    }
</mat-autocomplete>
